<template lang="pug">
  include /mixins
  +b.participant-document-view
    +e.content
      +e.preview
        +e.img.IMG(
          :src='item.img'
          v-if='!item.err'
        )
        +b.mask-img.LABEL(
          :class="{'mask-img--with-bg': item.err}"
        )
          +e.item.IMG(
            v-if='item.err'
            src='/static/img/error.svg'
          )
      +e.name.P {{ item.file.name }}
    +e.close(@click='removeItem(idx)')
      +e.icon.mdi.mdi-close

</template>
<script>
export default {
  name: 'AddImg',
  props: ['item', 'idx'],
  methods: {
    removeItem(idx) {
      this.$emit('removeItem', idx)
    },

  },
}
</script>
